export default __webpack_public_path__ + "static/media/7_720.18150a85.webp";